import React from 'react';

import { Box, Stack } from '@chakra-ui/react';
import { isEmpty } from 'lodash';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { customTheme } from 'theme';

import { SyntaxHighlight } from 'components/DataDisplay';

interface Props {
  generatedPolicy: string[];
  isInvalid: boolean;
}

export const GeneratedPolicy = (props: Props) => {
  const { generatedPolicy, isInvalid } = props;
  return (
    <Stack
      border="1px solid"
      borderRadius={6}
      borderColor="componentBorder"
      py={4}
      px={6}
      minH="400px"
    >
      <Box fontSize="lg" fontWeight={600}>
        Generated Native Policy
      </Box>
      <Box
        border="1px solid"
        borderRadius={6}
        borderColor="componentBorder"
        p={4}
        flex={1}
        h="full"
        bg={customTheme.colors.gray['50']}
      >
        {!isEmpty(generatedPolicy) && !isInvalid ? (
          <SyntaxHighlight
            language="sql"
            style={vscDarkPlus}
            //customStyle={{ margin: 0, background: 'transparent' }}
          >
            {generatedPolicy.join('\n')}
          </SyntaxHighlight>
        ) : (
          '--Policy will appear when you press the “Generate” button'
        )}
      </Box>
    </Stack>
  );
};
